import React from 'react'
import { SxProps } from '@mui/material/styles'
import { Box } from '@mui/material'
import Typography from '@mui/material/Typography'
import { Address as AddressType } from '../../../../types/address'
import Address from './Address'
import { DeliveryMethodType } from '../../../../types/deliveryMethodTypes'
import { Recipient as RecipientType } from '../../../../types/recipient'
import { localizeDate } from '../../../../utils/dates'
import { Payment } from '../../../../types/payment'
import {
  ACHReceivingMethod,
  WireReceivingMethod,
} from '../../../../types/recipient'
import { DELIVERY_METHOD_TITLE } from '../../../../utils/deliveryMethods'

export interface CheckDeliveryProps extends AddressType {
  recipientName: string
  sx?: SxProps
}

export interface PaymentDeliveryProps {
  payment: Payment
}

const renderDeliveryMetaData = (recipient: RecipientType) => {
  let receivingMethod
  switch (recipient?.receivingMethod.type) {
    case DeliveryMethodType.CHECK:
      return <Address {...recipient.address} />
    case DeliveryMethodType.WIRE:
      receivingMethod = recipient.receivingMethod as WireReceivingMethod
    case DeliveryMethodType.ACH:
      receivingMethod = recipient.receivingMethod as ACHReceivingMethod
      return (
        <Typography
          sx={theme => ({
            fontSize: '0.75rem',
            fontWeight: 400,
            lineHeight: 1.333,
            marginBottom: theme.spacing(0.75),
          })}
        >
          Routing: {receivingMethod.routingNumber} Account: *
          {receivingMethod.accountLastFour}
        </Typography>
      )
    default:
    // no-op
  }
}

const PaymentDelivery = (props: PaymentDeliveryProps) => {
  const { recipient, deliveryDate } = props.payment || {}
  return (
    <Box
      sx={theme => ({
        color: '#000000B2',
        marginTop: theme.spacing(2),
      })}
    >
      <Typography
        sx={theme => ({
          fontSize: '1rem',
          fontWeight: 400,
          lineHeight: 1.5,
          marginBottom: theme.spacing(0.75),
        })}
      >
        {DELIVERY_METHOD_TITLE[recipient.receivingMethod.type]} to{' '}
        <strong>{recipient.name}</strong>
      </Typography>
      {renderDeliveryMetaData(recipient)}
      <Typography
        sx={{
          fontSize: '0.75rem',
          fontWeight: 400,
          lineHeight: 1.333,
        }}
      >
        Your payment will arrive by {localizeDate(deliveryDate)}
      </Typography>
    </Box>
  )
}

export default PaymentDelivery
